import SvgIcon from 'material-ui/SvgIcon';

let OnlineBooking = (props) => (
    <SvgIcon {...props}
        viewBox="0 0 500 500" version="1.1" xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Online-Booking-2">
                <circle id="Oval-4" fill="#42A5F5" cx="250" cy="250" r="206"></circle>
                <path
                    d="M250,456 C363.770658,456 456,363.770658 456,250 C456,136.229342 363.770658,44 250,44 L250,456 Z"
                    id="Oval-4-Copy-3" fill="#1976D2"></path>
                <ellipse id="Oval-4-Copy" fill="#2196F3" cx="250" cy="250" rx="125" ry="206"></ellipse>
                <path
                    d="M250,456 C319.035594,456 375,363.770658 375,250 C375,136.229342 319.035594,44 250,44 L250,456 Z"
                    id="Oval-4-Copy-4" fill="#1E88E5"></path>
                <path
                    d="M250,456 C363.770658,456 456,363.770658 456,250 L44,250 C44,363.770658 136.229342,456 250,456 Z"
                    id="Oval-4-Copy-5" fillOpacity="0.1" fill="#000000" style={{mixBlendMode: 'overlay'}}></path>
                <g id="Group"
                   transform="translate(449.570200, 330.179584) rotate(-37.000000) translate(-449.570200, -330.179584) translate(408.570200, 260.679584)">
                    <path d="M40.8410646,80.881324 L40.8410646,138.561538" id="Line-2" stroke="#E0E0E0" strokeWidth="9"
                          strokeLinecap="square"></path>
                    <polygon id="Shape" fill="#E0E0E0" fillRule="nonzero"
                             points="40.8410646 0 0 99.5977429 3.86628745 103.46403 40.8410646 87.1276045 77.8158418 103.46403 81.6821292 99.5977429"></polygon>
                </g>
            </g>
        </g>
    </SvgIcon>
);

export default OnlineBooking;